import { Box, Text, ActionIcon } from '@mantine/core';
import { MaterialIcon } from '../common/MaterialIcon';

interface MemoHeaderProps {
  onAddClick: () => void;
}

export function MemoHeader({ onAddClick }: MemoHeaderProps) {
  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Text size="sm" fw={600}>
        圃場メモ
      </Text>
      <ActionIcon size="sm" variant="subtle" color="gray" onClick={onAddClick}>
        <MaterialIcon icon="add" size="sm" />
      </ActionIcon>
    </Box>
  );
}
